import { css } from 'lit';

export default css`
    /* Shadow levels from Figma */
    --shadow-100: 0px 2px 4px -2px rgba(19, 25, 39, 0.12), 0px 4px 4px -2px rgba(19, 25, 39, 0.08);
    --shadow-200: 0px 4px 6px -4px rgba(19, 25, 39, 0.12), 0px 8px 8px -4px rgba(19, 25, 39, 0.08);
    --shadow-300: 0px 6px 8px -6px rgba(19, 25, 39, 0.12), 0px 8px 16px -6px rgba(19, 25, 39, 0.08);
    --shadow-400: 0px 6px 12px -6px rgba(19, 25, 39, 0.12), 0px 8px 24px -4px rgba(19, 25, 39, 0.08);
    --shadow-500: 0px 6px 14px -6px rgba(19, 25, 39, 0.12), 0px 10px 32px -4px rgba(19, 25, 39, 0.1);
    --shadow-600: 0px 8px 18px -6px rgba(19, 25, 39, 0.12), 0px 12px 42px -4px rgba(19, 25, 39, 0.12);
    --shadow-700: 0px 8px 22px -6px rgba(19, 25, 39, 0.12), 0px 14px 64px -4px rgba(19, 25, 39, 0.12);
    --shadow-800: 0px 8px 28px -6px rgba(19, 25, 39, 0.12), 0px 18px 88px -4px rgba(19, 25, 39, 0.14);
`;